import tooltipManager from '~/plugins/tooltipManager';

export default {
  mounted(el, binding) {
    const showTooltip = () => {
      if (binding.value === '') {
        return;
      }

      if (binding.modifiers.truncated) {
        if (el.scrollWidth <= el.clientWidth) {
          return;
        }
      }

      tooltipManager.showTooltip(binding.value, el);
    };

    const hideTooltip = () => {
      tooltipManager.hideTooltip();
    };

    el.addEventListener("mouseenter", showTooltip);
    el.addEventListener("mouseleave", hideTooltip);
    el._tooltipHandlers = { showTooltip, hideTooltip };
  },
  updated(el, binding) {
    const oldShowTooltip = el._tooltipHandlers.showTooltip;

    const newShowTooltip = () => {
      if (binding.value === '') {
        return;
      }

      if (binding.modifiers.truncated) {
        if (el.scrollWidth <= el.clientWidth) {
          return;
        }
      }

      tooltipManager.showTooltip(binding.value, el);
    };

    el.removeEventListener("mouseenter", oldShowTooltip);
    el.addEventListener("mouseenter", newShowTooltip);
    el._tooltipHandlers.showTooltip = newShowTooltip;
  },
  unmounted(el) {
    const { showTooltip, hideTooltip } = el._tooltipHandlers;
    el.removeEventListener("mouseenter", showTooltip);
    el.removeEventListener("mouseleave", hideTooltip);
    hideTooltip();
    delete el._tooltipHandlers;
  }
};